// extracted by mini-css-extract-plugin
export default {"bonusBox":"dY_lP","detailsBox":"dY_d4","firstPart":"dY_ph","secondPart":"dY_pj"};